export const kioskStatusRowStyles = {
  btnDetails: {
    border: '1px solid #7c7c7c',
    fontSize: '11px'
  },
  btnService: {
    border: '1px solid #75cc7b',
    backgroundColor: '#bde6bf',
    color: '#1cab26',
    fontSize: '10px',
    fontWeight: 'bold'
  },
  btnWithoutService: {
    border: '1px solid #e72441',
    backgroundColor: '#f18091',
    color: '#e72442',
    fontSize: '10px',
    fontWeight: 'bold'
  },
  btnWarning: {
    border: '1px solid #f3c15a',
    backgroundColor: '#f8da9d',
    color: '#655f52',
    fontSize: '10px',
    fontWeight: 'bold',
    width: '110px'
  }
}
